import { render, staticRenderFns } from "./TaxIndex.vue?vue&type=template&id=4368bde0&scoped=true"
import script from "./TaxIndex.vue?vue&type=script&lang=js"
export * from "./TaxIndex.vue?vue&type=script&lang=js"
import style0 from "./TaxIndex.vue?vue&type=style&index=0&id=4368bde0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368bde0",
  null
  
)

export default component.exports